/* eslint-disable default-case, no-param-reassign */
/*
 * SSO Consent reducer
 *
 */

import produce from 'immer';

import { CHANGE_INPUT, RESET_CONSENT } from './constants';

/*
  TODO: when consentsNeeded values are fetched, set consent form
        values to their opposites in reducer case
*/
export const initialState = {
  consentsNeeded: {
    electronicCommunicationsPolicy: true,
    estatementPolicy: true,
    privacyPolicy: true,
    termsOfUse: true,
  },
  forms: {
    consent: {
      electronicCommunicationsPolicy: false,
      estatementPolicy: false,
      privacyPolicy: false,
      termsOfUse: false,
    },
  },
};

const ssoConsentReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_INPUT: {
      const { field, form, value } = payload;
      draft.forms[form][field] = value;
      break;
    }
    case RESET_CONSENT: {
      draft.forms.consent = initialState.forms.consent;
      break;
    }
  }
}, initialState);

export default ssoConsentReducer;
